import select2 from 'select2';

select2();

window.initSelect2 = (root = document) => {
  $(root).find('select:not([data-skip-select2])').not('.select2-hidden-accessible').each(function () {
    const modal = $(this).closest('.modal');

    $(this).select2({
      minimumResultsForSearch: this.dataset.updateSearchResult || 0,
      dropdownParent: modal.length ? modal : $(document.body)
    }).on('select2:select select2:unselect', () => {
      // select2 publishes its pick as a jQuery event only; relay a native one so Stimulus actions react
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
};

$(document).ready(() => window.initSelect2());
